module.exports = __webpack_public_path__ + "static/img/840_phase_function_Paper_PointsHejduk_Prediction.3471aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/840_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iYeR
// module chunks = 0